import { cn } from '@/lib/utils';

type Tone = 'ok' | 'warn' | 'danger' | 'neutral';

const toneClass: Record<Tone, string> = {
  ok: 'bg-success',
  warn: 'bg-warn',
  danger: 'bg-destructive',
  neutral: 'bg-muted-2',
};

interface StatusDotProps {
  tone?: Tone;
  size?: number;
  className?: string;
}

export function StatusDot({ tone = 'neutral', size = 6, className }: StatusDotProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block shrink-0 rounded-full', toneClass[tone], className)}
      style={{ width: size, height: size }}
    />
  );
}
